module.exports = __webpack_public_path__ + "static/media/ceb-logo.f03c75fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SignUp/ceb-logo.svg
// module id = 312
// module chunks = 0